import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['collapsibleBlock', 'content', 'button', 'gradient']

  connect() {
    this.checkHeightContent()
  }

  toggle() {
    this.collapsibleBlockTarget.classList.toggle('max-h-full')
    this.gradientTarget.classList.toggle("hidden")
    this.buttonTarget.textContent = this.collapsibleBlockTarget.classList.contains('max-h-full') ? 'Свернуть' : 'Читать далее'
  }

  checkHeightContent() {
    const heightContent = this.contentTarget.offsetHeight

    if ((heightContent - 320) < 100) {
      this.collapsibleBlockTarget.classList.add("max-h-full")
      this.buttonTarget.classList.add("hidden")
      this.gradientTarget.classList.add("hidden")
    }
  }

}